import React from 'react';
import { PopUp, Button } from 'geniebook-ui/dist';
import { useViewWidth } from '@utils/helpers/viewWidth';
import { useUpdateMasterySurveyStatus } from '@hooks/user.hook';
import { CDN_URL } from '@utils/constants/url.constants';
import '@assets/css/mastery_popup.css';

const breakpoint = require('geniebook-ui/dist/themes/breakpoint');

export interface MasterySurveyProps {
  showMasterySurvey: () => void;
}

const MasterySurvey = ({ showMasterySurvey }: MasterySurveyProps) => {
  const viewWidth = useViewWidth();

  const ButtonGroup = () => {
    return (
      <div className={'w-full'}>
        <Button className="mb-2" onClick={openMasterySurvey}>
          Proceed to survey
        </Button>
        <Button variant="secondary" onClick={hideUnlockPopup}>
          Not now
        </Button>
      </div>
    );
  };

  const update_survey_status = useUpdateMasterySurveyStatus();

  const openMasterySurvey = () => {
    window.open('https://forms.gle/t1Rud7FutnqKQxjG9', '_blank');
    update_survey_status.mutate();
    showMasterySurvey();
  };

  const hideUnlockPopup = () => {
    showMasterySurvey();
  };

  return (
    <div id={'mastery-survey-popup'}>
      <PopUp
        img={`${CDN_URL}assets/images/Illust_Empty State_GenieAsk.svg`}
        title="What did you think of Skill Levels?"
        description="Your opinion matters! Take our quick survey and let us know what you thought of our Skill Levels"
        buttonGroup={ButtonGroup()}
        onClose={() => {}}
        disableBodyScroll={true}
        width={viewWidth < breakpoint.md ? `${viewWidth - 30}px` : '400px'}
      />
    </div>
  );
};

export default MasterySurvey;
